import React, { memo,
     useEffect,
    useState,
        } from 'react';
import {Col, Row} from 'react-bootstrap';

//import { Checkbox } from '@material-ui/core';
import moment from 'moment';
import { Checkbox } from '@material-ui/core';

//import TaetigkeitVerortung from '../Components/TaetigkeitVerortung'
//import AppWebReportStundenReportEmployeeTable from "./AppWebReportStundenReportEmployeeTable";
//import Bulb from "react-bulb/index";
import AppWebReportStundenAuftraggeber from "./AppWebReportStundenAuftraggeber";
import AppWebReportStundenMaterial from "./AppWebReportStundenMaterial";
import AppWebReportStundenGeraete from "./AppWebReportStundenGeraete";
import AppWebReportStundenKostenschaetzung from "./AppWebReportStundenKostenschaetzung";
import AppWebReportFreigabe from "./AppWebReportFreigabe";
//import AppWebReportWorkDone from "./AppWebReportWorkDone";
import AppWebReportZeit from "./AppWebReportZeit";
import AppWebReportTaetigkeitVerortung from "./AppWebReportTaetigkeitVerortung";
import AppWebReportStundenReportEmployeeTable from "./AppWebReportStundenReportEmployeeTable";
import Bulb from "react-bulb";
import AppWebReportWorkDone from "./AppWebReportWorkDone";
import AppWebReportStundenActionButtonsComponent from "./AppWebReportStundenActionButtonsComponent";

function AppWebReportStundenPage(props) {
    //let [rDate, setRDate] = useState(null);
    //let [cDate, setCDate] = useState(null);
    //let [tValue, setTValue] = useState('');
    //
    // let [donerDate, setDoneRDate] = useState(null)
    // let [donecDate, setDoneCDate] = useState(null)
    // let [donetValue, setDoneTValue] = useState("")
    //
    const [repeatStatus, setRepeatStatus] = useState(false)
     const [stundenReportData, setStundenReportData] = useState({})

    // const [completeData, setCompleteData] = useState({})
     const [abmeldungState, setAbmeldungState] = useState(false)
    //
     const [stundenTitle, setStundenTitle] = useState("")
     const [creatorFirstName, setCreatorFirstName] = useState("")
     const [creatorLastName, setCreatorLastName] = useState("")
     const [creationDate, setCreationDate] = useState("")
     const [materialData, setMaterialData] = useState([])
    // const [projectData, setProjectData] = useState({})
    // let [metadata, setMetaData] = useState({})
    //
    //
    // const [pID, setPID] = useState(sessionStorage.getItem('projectID'));
    //
    // const [isChange, setIsChange] = useState(false);


    useEffect(() => {

        async function getStundenReportData() {

            let data = JSON.parse(JSON.stringify(props.reportData))
            console.log(data, 444666);
            let dataToShow = []
            if (props.reportType === "Stunden-Anmeldung")
            {
                dataToShow = data.anmeldungData
                console.log(dataToShow.material_angemeldet,11)
                //setRDate(dataToShow.auftraggeber_confirmation[0].registerDate)
                //setCDate(dataToShow.auftraggeber_confirmation[0].confirmationDate)
                //setTValue(dataToShow.auftraggeber_confirmation[0].confirmationType)
                setMaterialData(dataToShow.material_angemeldet)
                setAbmeldungState(false)
                //setAnmeldungState(true)
            }
            else if (props.reportType === "Stunden-Abmeldung")
            {
                dataToShow = data.abmeldungData
                setAbmeldungState(true)
                //let g = JSON.parse(JSON.stringify(dataToShow.auftraggeber_done))
                /*dataToShow.auftraggeber_done =
                    [
                        {
                            firstName: g.firstName,
                            lastName: g.lastName,
                            role: g.role,
                            entscheidungsbefugnis: g.entscheidungsbefugnis,
                        }
                        ];*/
               setMaterialData(dataToShow.material_abgemeldet)
            }
            //setDoneRDate(g.doneDate)
            //setDoneCDate(g.confirmationDate)
            //setDoneTValue(g.confirmationType)
            setStundenReportData(dataToShow);
            //setPID(dataToShow.projectID);
            setStundenTitle(dataToShow.stundenlohnTitle);

            setCreatorFirstName(
                dataToShow.auftraggeber_registeration && dataToShow.auftraggeber_registeration[0]
                    ? dataToShow.auftraggeber_registeration[0].firstName
                    : 'NA'
            );
            setCreatorLastName(
                dataToShow.auftraggeber_registeration && dataToShow.auftraggeber_registeration[0]
                    ? dataToShow.auftraggeber_registeration[0].lastName
                    : 'NA'
            );
            setCreationDate(
                dataToShow.creationDate
                    ? moment(dataToShow.creationDate, 'YYYY-MM-DDTHH:mm:ss.SSS').format('DD-MM-YYYY')
                    : moment().format('DD-MM-YYYY')
            );

            setRepeatStatus(dataToShow.repeat_status);

            //get meta and project
            /*            apiBody = {
                            token: getToken(),
                            data: {
                                dataID: dataID
                            }
                        };
                        let res = await fetch(process.env.REACT_APP_BACKEND_API_URI + 'mobileappbackend/get_onemetaandproject', {
                            method: 'POST',
                            headers: {
                                'Content-type': 'application/json'
                            },
                            body: JSON.stringify(apiBody)
                        })
                            .then((response) => response.json())
                            .catch((error) => {
                                console.error('Error:', error);
                            });
                        console.log(res, 'projandmetadata');
                        setProjectData(res.proj_data);
                        setMetaData(res.meta_data);*/
        }

        getStundenReportData().then((r) => r);
    }, []);

    useEffect(() => {
        console.log(stundenReportData);
    }, [stundenReportData]);

    return (
        <div
            style={{
                width: '100%'
            }}
            className="handwai-dark"
        >
            <div
                style={{
                    padding: 40,
                    width: '100%'

                }}
            >

                <Row>
                    <Col sm={8}>
                        {props.reportType==="Stunden-Anmeldung" && (
                            <label style={{ fontSize: 40 }} className="handwai-text-label-main add-bottom-0-margin">
                                {'Stundenlohn - Anmeldung: ' + stundenTitle}
                            </label>
                        )}
                        {props.reportType==="Stunden-Abmeldung" && (
                            <label style={{ fontSize: 30 }} className="handwai-text-label-main add-bottom-0-margin">
                                {'Stundenlohn - Ausführung: ' + stundenTitle}
                            </label>
                        )}
                        <br />
                        <label className="handwai-text-label-normal add-bottom-0-margin">
                            {'Ersteller: ' +
                                creatorFirstName +
                                ' ' +
                                creatorLastName +
                                ', ' +
                                'Erstellungsdatum: ' +
                                creationDate}
                        </label>
                    </Col>
                    <Col sm={7}></Col>
                    <Col />
                </Row>
                <br />
                <Row>
                    <Col sm={6}></Col> <Col />
                    <Col sm={5} />
                </Row>
                <Row>
                    <Col sm={6}></Col> <Col />
                    <Col sm={5} />
                </Row>

                <Row>
                    {
                        abmeldungState && (
                        <>
                            <Col sm={5} md={5} lg={5}>
                                <AppWebReportStundenReportEmployeeTable
                                    employeeData={stundenReportData.coworkers}
                                />
                            </Col>
                            {stundenReportData.workDone && (
                                <Col sm={3}>
                                    <label
                                        style={{ fontSize: 40, color: 'green' }}
                                        className="handwai-text-label-main add-bottom-0-margin"
                                    >
                                        Abgeschlossen
                                    </label>
                                </Col>
                            )}
                            {!stundenReportData.workDone && (
                                <Col sm={3}>
                                    <label
                                        style={{ fontSize: 40, color: 'red' }}
                                        className="handwai-text-label-main add-bottom-0-margin"
                                    >
                                        Nicht Abgeschlossen
                                    </label>
                                </Col>
                            )}

                            <Col sm={0.5}>
                                <Bulb size={30} color={stundenReportData.workDone === true ? 'green' : 'red'} />
                            </Col>
                        </>
                    )
                    }

                    {!abmeldungState && (
                        <Col sm={12}>
                            <AppWebReportZeit
                                estimation={stundenReportData.estimation}
                            />
                        </Col>
                    )}
                </Row>
                <Row>
                    <Col sm={12}>
                        <AppWebReportStundenAuftraggeber
                            auftraggeberData={stundenReportData.auftraggeber_registeration}
                        />
                    </Col>
                </Row>
                <br />
                <br />
                <br />
                <Row>
                    <Col sm={4}>
                        <label className="handwai-text-label-main">{'Tätigkeit'}</label>
                    </Col>
                    <Col sm={7}></Col>
                    <Col />
                </Row>
                <br />


                <div
                    className="tatigkeiten-div-scroll"
                    style={{
                        width: '100%',
                        height:'50vh',
                        // backgroundColor: 'red',
                        display: 'flex',
                        // padding: 20
                    }}
                >
                    <AppWebReportTaetigkeitVerortung
                        setStundenReportData={setStundenReportData}
                        stundenReportData={stundenReportData}
                        type={props.reportType}
                    />
                     {/*{multipletatigkeitimages()}*/}
                </div>


                <br /> <br />

                <Row>
                    <Col sm={7}>
                        <AppWebReportStundenMaterial
                            materialData={materialData}
                        />
                    </Col>

                    <Col sm={4}>
                        <AppWebReportStundenGeraete
                            geraeteData={stundenReportData?.material_geraet}
                        />
                    </Col>
                    <Col />
                </Row>

                <br /> <br />
                {!abmeldungState && (
                    <>
                        <AppWebReportStundenKostenschaetzung
                            kosten={stundenReportData.cost_estimation}
                        />
                        <br /> <br />
                        <Row>
                            <Col sm={11}>
                                <AppWebReportFreigabe
                                    confirmationdata={stundenReportData?.auftraggeber_confirmation}
                                />
                            </Col>
                        </Row>
                    </>
                )}



                {abmeldungState && (
                    <Row>
                        <Col sm={11}>
                            <AppWebReportWorkDone
                                doneData={stundenReportData?.auftraggeber_done}
                            />
                        </Col>
                    </Row>
                )}
                <br />
                <br />

                {abmeldungState && (
                    <Row>
                        <Col
                            sm={1}
                            style={{
                                marginRight: -100
                            }}
                        >
                            <div>
                                <Checkbox
                                    style={{
                                        backgroundColor: 'white',
                                        width: '30%'
                                    }}
                                    color="grey"
                                    disabled={true}
                                    defaultChecked={repeatStatus}

                                />
                            </div>
                        </Col>
                        <Col sm={1} style={{ textAlign: 'Center', verticalAlign: 'Center' }}>
                            <label className="handwai-text-label-normal add-bottom-0-margin">
                                {"Teilabmeldung:Anmeldung wird nicht gelöscht"}
                                {'Abmeldung Beenden'}
                            </label>
                        </Col>
                    </Row>
                )}



            </div>
            <br />
            <br />
            <div className="horizontal-line"></div>






            <div style={{ width: '100%' }}>
                <AppWebReportStundenActionButtonsComponent
                    stundenReportData={props.reportData}
                    type={props.reportType}

                />
            </div>


            <br />
            <br />
        </div>

    );
}

export default memo(AppWebReportStundenPage);
